import { typedQueryClient, useTypedQuery } from "hooks";
import { WarrantyQueryKeys } from "modules/WarrantyDashboard/queryKeys";

export const useIsExportModalOpen = () => useTypedQuery({ queryKey: WarrantyQueryKeys.isExportModalOpen, initialData: false }).data;
export const setIsExportModalOpen = (open: boolean) => typedQueryClient.setQueryData(WarrantyQueryKeys.isExportModalOpen, open);
